module.exports = __webpack_public_path__ + "img/bi-typo.8d71591d.svg";